package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.animations.AppStylesAnimations
import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesControls : StyleSheet() {

    val controlsRow by style {
        padding(14.px, 20.px)
        property("border-top", "1px solid ${AppStylesTokens.BORDER}")
        backgroundColor(Color(AppStylesTokens.CARD))

        property("border-bottom-left-radius", "${AppStylesTokens.RADIUS_PAGE}px")
        property("border-bottom-right-radius", "${AppStylesTokens.RADIUS_PAGE}px")

        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        gap(12.px)
    }

    val rightControls by style {
        display(DisplayStyle.Flex)
        gap(10.px)
        property("margin-left", "auto")
        alignItems(AlignItems.Center)
    }

    val btnPrimary by style {
        padding(10.px, 18.px)
        borderRadius(16.px)
        fontSize(14.px)
        fontWeight(700)

        backgroundColor(Color("rgba(102,96,230,0.78)"))
        color(Color("#FFFFFF"))

        property("border", "1px solid rgba(102,96,230,0.40)")
        property(
            "box-shadow",
            "0 2px 6px rgba(102,96,230,0.12), inset 0 1px 0 rgba(255,255,255,0.10)"
        )
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)

        self + hover style {
            backgroundColor(Color("rgba(102,96,230,0.82)"))
            property("border", "1px solid rgba(102,96,230,0.45)")
            property("transform", "translateY(-1px)")
            property(
                "box-shadow",
                "0 3px 10px rgba(102,96,230,0.14), inset 0 1px 0 rgba(255,255,255,0.10)"
            )
        }

        self + active style {
            property("transform", "translateY(0)")
            backgroundColor(Color("rgba(102,96,230,0.65)"))
            property(
                "box-shadow",
                "0 1px 3px rgba(102,96,230,0.10), inset 0 1px 0 rgba(255,255,255,0.05)"
            )
        }

        self + disabled style {
            property("opacity", "0.55")
            property("cursor", "not-allowed")
            property("transform", "none")
        }

        self + focus style {
            property("outline", "none")
            property("box-shadow", AppStylesTokens.FOCUS_RING)
        }
    }

    val btnPrimaryLoading by style {
        property("cursor", "wait")
        property("opacity", "0.92")
    }

    /** Bouton Envoyer désactivé : un peu plus petit que btnPrimary, fond gris clair, texte et icône gris moyen */
    val sendButtonDisabled by style {
        padding(8.px, 14.px)
        borderRadius(14.px)
        fontSize(13.px)
        fontWeight(700)
        backgroundColor(Color("#E8E8E8"))
        color(Color("#757575"))
        property("border", "1px solid rgba(0,0,0,0.06)")
        property("box-shadow", "none")
        property("cursor", "not-allowed")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val tertiaryButton by style {
        backgroundColor(Color("rgba(255,255,255,0.88)"))
        color(Color("rgba(94,99,117,0.92)"))
        padding(10.px, 14.px)
        borderRadius(12.px)
        fontSize(14.px)
        fontWeight(520)
        property("border", "1px solid rgba(15,23,42,0.08)")
        property("box-shadow", AppStylesTokens.SHADOW_BTN_TERTIARY)
        property("cursor", "pointer")
        property("transition", AppStylesTokens.TRANSITION_FAST)

        self + hover style {
            backgroundColor(Color("rgba(255,255,255,0.96)"))
            property("border", "1px solid rgba(102,96,230,0.18)")
            property("transform", "translateY(-1px)")
            property("box-shadow", "0 12px 26px rgba(15,23,42,0.05)")
        }
        self + active style { property("transform", "translateY(0)") }

        self + focus style {
            property("outline", "none")
            property("box-shadow", "none")
        }
    }

    val sendSpinner by style {
        display(DisplayStyle.InlineBlock)
        width(16.px)
        height(16.px)
        property("border-radius", "50%")
        property("border", "2px solid rgba(255,255,255,0.35)")
        property("border-top-color", "#FFFFFF")
        property("animation", "${AppStylesAnimations.spin.name} 800ms linear infinite")
        property("margin-right", "12px")
        property("vertical-align", "middle")
    }

    val sendSpinnerText by style {
        fontWeight(600)
        display(DisplayStyle.InlineBlock)
    }

    val sendSuccessIcon by style {
        property("display", "inline-flex")
        width(18.px)
        height(18.px)
        property("align-items", "center")
        property("justify-content", "center")
        property("border-radius", "50%")
        property("margin-right", "10px")
        fontWeight(700)
        color(Color("#FFFFFF"))
    }

    val sendSuccessText by style {
        fontWeight(600)
        color(Color("#FFFFFF"))
    }

    val sendErrorText by style {
        property("animation", "${AppStylesAnimations.shake.name} 0.5s")
    }

    /** Contenu du bouton Envoyer : icône + texte alignés */
    val sendBtnContent by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
    }

    /** Icône send (avion) dans le bouton Envoyer */
    val sendIconSvg by style {
        width(16.px)
        height(16.px)
        flexShrink(0)
    }
}
